import { BaseModel } from '@tcc-mono/shared/data-access';

export class Team extends BaseModel {
  id: string;
  name: string;
  activeGameSessionsCount?: number;
  remarks?: string;
}
